'use client';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';
import cx from 'classnames';
import styles from '../anchor-menu.module.scss';
import { Conditional } from '@cat-ecom/pcc-components';

export interface HoseWarningProps {
  hoseWarning?: string;
  viewBtnShwn?: boolean;
}

const HoseWarning = ({ hoseWarning, viewBtnShwn = true }: HoseWarningProps) => {
  const t = useTranslations();
  const [viewMore, setViewMore] = useState(true);
  const warningText = viewMore ? `${hoseWarning?.split('.')[0]}.` : hoseWarning;

  return (
    <>
      <div className="mb-0 ms-4">
        <div className="cat-u-theme-typography-footnote-bold">
          {t('CAT_HOSE_WARNING_HEADER')}
        </div>
        <div className="cat-u-theme-typography-footnote">
          {viewBtnShwn ? warningText : hoseWarning}
        </div>
      </div>
      <Conditional test={viewBtnShwn}>
        <CatButton
          className={cx(
            styles['hose-warning__btn'],
            'cat-u-theme-typography-body-sm'
          )}
          data-testid="cat-button"
          size="sm"
          variant="ghost"
          onClick={() => setViewMore((viewMore) => !viewMore)}
        >
          {viewMore ? t('VIEW_MORE_PRODUCTS') : t('VIEW_LESS')}
        </CatButton>
      </Conditional>
    </>
  );
};

export default HoseWarning;
